import { downloadPdfByDepositId } from '../services/depositService';

export const downloadDepositPdf = async (id, loadingCallback) => {
  loadingCallback(true);
  try {
    await downloadPdfByDepositId(id)
      .then(
        (response) =>
          new Blob([response.data], {
            type: 'application/pdf',
          }),
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `gava_${id}.pdf`;
        a.click();
        a.remove();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          loadingCallback(false);
        }, 100);
      });
  } catch (err) {
    loadingCallback(false);
  }
};
